module.exports = __webpack_public_path__ + "img/courseSelection.062843c9.png";